import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    regionInfoProvider: defaultRegionInfoProvider,
    signingEscapePath: false,
    signingName: "s3",
};
//# sourceMappingURL=runtimeConfig.shared.js.map